import React, { useState, useRef, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import BASE_URL from 'components/BaseUrl/apiConfig';
import Navbar from 'components/Navbars/IndexNavbar';
import Footer from 'components/Footers/Footer';
import Swal from 'sweetalert2';
import BlockUiOverlay from 'components/Expense/BlockUiOverlay';
import AnimatedCard from 'react-animated-3d-card';

import {
  setLocalStorageData,
  getLocalStorageData,
  clearLocalStorage,
  setLogoutTimer,
} from './localStorageUtil';

export default function Login() {



  const history = useHistory();
  const userNameInputRef = useRef(null);

  const [formData, setFormData] = useState({
    password: '',
    userName: '',
  });

  const [errors, setErrors] = useState({
    password: '',
    userName: '',
  });

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    // Focus on the userName input when the component mounts
    userNameInputRef.current.focus();

    // Check karein ki local storage mein user data hai ya nahi
    const storedData = getLocalStorageData();
    if (storedData) {
      const { userName, userId } = storedData;
      //setFormData({ userName, password: '' });

      // Set Logout timer
      //  setLogoutTimer(() => clearLocalStorageAndRedirect(), 1 * 60 * 1000);
    }
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Clear the error for the changed field
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    const newErrors = {};
    if (!formData.userName.trim()) {
      newErrors.userName = 'Username is required.';
    }

    if (!formData.password.trim()) {
      newErrors.password = 'Password is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      // There are validation errors
      setErrors(newErrors);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/api/Users/Login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userName: formData.userName,
          password: formData.password,
        }),
      });

      if (!response.ok) {
        // Handle unsuccessful login (e.g., display an error message)
        const errorData = await response.json();

        setLoading(false);

        if (errorData.msg === 'Please Verify your Email!') {
          history.push('/verifyEmail');

          Swal.fire({
            icon: 'error',
            title: 'Verify Email',
            text: 'Your Email is not Verified. Please Verify your Email! ',
          });

          return;
        }
        else if (errorData.msg === 'Please contact your administrator.') {
          Swal.fire({
            icon: 'error',
            title: 'Something went wrong.',
            text: 'Please contact your administrator.',
          });

          return;
        }

        Swal.fire({
          icon: 'error',
          title: 'Invalid credentials.',
          text: errorData.msg,

        });

        return;
      }

      const responseData = await response.json();

      if (responseData.success) {
        const userData = responseData.user;
        console.log(userData);
        // Store user data in local storage
        setLocalStorageData({ userName: userData.userName, userId: userData.userId, userTypeId: userData.userTypeId, groupId: userData.groupId });

        if (userData.userTypeId === 1) {
          history.push('/admindashboard');
        } else {
          // Redirect to the dashboard or desired page
          history.push('/dashboard'); // Replace '/dashboard' with your actual dashboard route
        }

        // Set Logout timer
        setLogoutTimer(() => clearLocalStorageAndRedirect(), 20 * 60 * 1000);

        setLoading(false);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong.',
        text: error,
      });
      setLoading(false);
    }
  };


  const clearLocalStorageAndRedirect = () => {
    // Local storage ko clear karein
    clearLocalStorage();

    // Redirect to login page
    history.push('/login');
  };




  return (
    <>
      <Navbar />
      <div >
        <div className="container mx-auto mb-3 px-4 h-full">
          <div className='flex flex-wrap'>

            <div className='hidden md:block w-full xl:w-8/12 xl:mb-0 px-4'>
              <div className='p-12 mt-12 ml-auto mr-auto text-center'>
                <h2 style={{ fontSize: '45px', color: 'black' }}>What you will get inside!</h2>
              </div>

              <div className="flex justify-center ">
                {/* First Card */}
                <div style={{ marginRight: '20px', marginTop: '20px' }}>
                  <AnimatedCard
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: 'ease'
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70
                      }
                    }}
                    style={{
                      width: '190px',
                      height: 'auto', // Adjusted height to accommodate variable content
                      borderRadius: '10px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
                      backgroundColor: 'white',
                      display: 'flex', // Added display flex to ensure proper alignment
                      flexDirection: 'column', // Set flex direction to column for stacking items
                      justifyContent: 'center', // Center items vertically
                      alignItems: 'center' // Center items horizontally
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: 'white',
                        flexGrow: '1', // Allow front content to grow to fill available space
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }
                    }}
                    back={{
                      style: {
                        backgroundColor: 'white',
                        flexGrow: '1', // Allow back content to grow to fill available space
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }
                    }}
                  >
                    {/* Content for Front */}
                    <img src={require('assets/img/Expense Management.jpeg')} alt="Card Image" className="w-full h-auto object-cover" />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">Expense Tracking</h2>
                    </div>
                  </AnimatedCard>
                </div>


                {/* Second Card */}
                <div style={{ marginRight: '20px', marginTop: '20px' }}>
                  <AnimatedCard
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: 'ease'
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70
                      }
                    }}
                    style={{
                      width: '190px',
                      height: 'auto',
                      borderRadius: '10px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
                      backgroundColor: 'white'
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: 'white'
                      }
                    }}
                    back={{
                      style: {
                        backgroundColor: 'white'
                      }
                    }}
                  >
                    <img src={require('assets/img/Quantity Management.jpeg')} alt="Card Image" className="w-full h-48 object-cover" />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">Quantity Tracking</h2>
                    </div>
                  </AnimatedCard>
                </div>

                {/* Third Card */}
                <div style={{ marginRight: '20px', marginTop: '20px' }}>
                  <AnimatedCard
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: 'ease'
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70
                      }
                    }}
                    style={{
                      width: '190px',
                      height: 'auto',
                      borderRadius: '10px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
                      backgroundColor: 'white'
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: 'white'
                      }
                    }}
                    back={{
                      style: {
                        backgroundColor: 'white'
                      }
                    }}
                  >
                    <img src={require('assets/img/Notes.jpeg')} alt="Card Image" className="w-full h-48 object-cover" />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">Notes</h2>
                    </div>
                  </AnimatedCard>
                </div>


                {/* Forth Card */}
                <div style={{ marginRight: '20px', marginTop: '20px' }}>
                  <AnimatedCard
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: 'ease'
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70
                      }
                    }}
                    style={{
                      width: '190px',
                      height: 'auto',
                      borderRadius: '10px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
                      backgroundColor: 'white'
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: 'white'
                      }
                    }}
                    back={{
                      style: {
                        backgroundColor: 'white'
                      }
                    }}
                  >
                    <img src={require('assets/img/uploaddocuments.jpg')} alt="document Image" className="w-full  object-cover" style={{ height: '162px' }} />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">Documents Management</h2>
                    </div>
                  </AnimatedCard>
                </div>
              </div>

            </div>

            {/* here is the code of the login section */}
            <div className="w-full xl:w-4/12 px-4">
              <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                <div className="rounded-t mb-0 px-6 py-6">
                  {/* <div className="text-right ">
                    <button
                      //onClick={navigateAddUser}
                      className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                      type="button"
                    >
                      Back
                    </button>
                  </div> */}
                  <div className="text-center mb-3">
                    <h2 className="text-blueGray-800 text-2xl font-bold">Sign in to your account</h2>
                  </div>
                  <hr className="mt-6 border-b-1 border-blueGray-300" />
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                  <form onSubmit={handleSubmit}>

                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="userName"
                      >
                        Username or email
                      </label>
                      <input
                        type="text"
                        name="userName"
                        ref={userNameInputRef}
                        value={formData.userName}
                        onChange={handleChange}
                        className=" border rounded w-full"
                        placeholder="Username or email address"
                      />
                      {errors.userName && <p style={{ color: 'red' }}>{errors.userName}</p>}
                    </div>
                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase  text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="password"
                      >
                        Password
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className=" border rounded w-full"
                        placeholder="Password"
                      />
                      {errors.password && <p style={{ color: 'red' }}>{errors.password}</p>}
                    </div>
                    <div className="text-center mt-6">
                      <button
                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                        type="submit"
                      >
                        Sign In
                      </button>
                    </div>
                    <div className="w-full flex flex-wrap mt-6 relative justify-between">
                      <div>
                        <Link to="/forgotpassword" className="text-blue-200">
                          <small>Forgot Password?</small>
                        </Link>
                      </div>
                      <div className="ml-auto">
                        <Link to="/userRegister" className="text-blue-200">
                          <small>Don't have an account? Sign Up</small>
                        </Link>
                      </div>
                      <BlockUiOverlay visible={loading} />
                    </div>


                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
